'use client';

import type { PublicRuntimeConfig } from '@/lib/config/runtime-config';

export default function RuntimeConfigProvider({ config, children }: { config: PublicRuntimeConfig; children: React.ReactNode }) {
  // Assign before React renders descendants. Lazy config getters used by child
  // components can then resolve runtime values without relying on script order.
  if (typeof window !== 'undefined') window.__AETHERA_RUNTIME_CONFIG__ = config;
  return children;
}
